<div>

  <div class="section-hero">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="text-center">
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <h1>Welcome more remote workers to your space</h1>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

  <div class="section-how-it-works">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6 offset-lg-1">
          <div>
            <h2>The leading provider of on-demand coworking</h2>
            <br/>
            <p>Croissant is the app for promoting your shared workspace to a <strong>targeted audience</strong> of small teams, entrepreneurs, freelancers, &amp; digital workers.</p>
            <p>From the moment your listing goes live, the door opens to leads, new members, &amp; additional revenue sources, all while maintaining full control of your space and inventory.</p>
            <p>We've partnered with coworking spaces, hotels, coffee shops, and event venues around the world.</p>

            <br/>
            <br/>


            <div class="row">
              <div class="col text-center">
                <h1>{{ NUM_SPACES }}+</h1>
                <h4>Space partners</h4>
                <br/>
              </div>
              <div class="col text-center">
                <h1>{{ NUM_CITIES }}+</h1>
                <h4>Cities worldwide</h4>
                <br/>
              </div>
              <div class="col text-center">
                <h1>{{ NUM_MEMBERS }}+</h1>
                <h4>Members</h4>
                <br/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xxl-3 offset-xxl-1 hide-sm hide-md hide-lg">
          <picture>
            <source srcset="/images/partners/iphone6.webp" type="image/webp">
            <img class="img-responsive" src="/images/partners/iphone6.png" alt="Croissant mobile app on iPhone"/>
          </picture>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

  <div class="section-benefits">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="row">
            <div class="col-12 text-center">
              <picture>
                <source srcset="/images/partners/squiggle.webp" type="image/webp">
                <img src="/images/partners/squiggle.png" height="15px" alt="Decorative squiggle"/>
              </picture>
            </div>
          </div>
          <br/>
          <br/>
          <br/>
          <div class="row">
            <div class="col text-center">
              <h3>Reach a new clientele embracing the nomad lifestyle</h3>
              <br/>
              <p>Target a vibrant community fond of trying new workspaces</p>
            </div>
          </div>
          <br/>
          <br/>
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="benefits">
                <p><strong>Grow your revenue</strong></p>
                <p>With Croissant, you can maximize your inventory usage rates by listing any of your available seats, all at the touch of a button. Croissant pays you for each member that checks in at your space.</p>
              </div>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-sm-6">
              <div class="benefits">
                <p><strong>Acquire new members</strong></p>
                <p>Croissant brings potential leads to your front door. Many folks are in the market for a dedicated desk or office. When you list with Croissant, people get a chance to fall in love with your space.</p>
              </div>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-sm-6">
              <div class="benefits">
                <p><strong>Raise brand awareness</strong></p>
                <p>Get the word out about your coworking space. We'll help share exciting news and upcoming events via social media &amp;newsletter shoutouts. Use our community tools to connect with Croissant members.</p>
              </div>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-sm-6">
              <div class="benefits">
                <p><strong>Make the most of amenities</strong></p>
                <p>
                  Have conference rooms, mailing address service, events, lockers, or even 3D printers? Leverage your amenities and generate
                  revenue by opening them up to Croissant members.
                </p>
              </div>
              <br/>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <br/>
  <br/>
  <br/>

  <div class="section-quotes">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="row">
            <div class="col-12 text-center">
              <h3>What our partners say about us</h3>
            </div>
          </div>
          <br/>
          <br/>
          <br/>

          <div class="row">
            <div class="col-auto">
              <picture>
                <source srcset="/images/partners/partner-stella.webp" type="image/webp">
                <img src="/images/partners/partner-stella.png" class="img-responsive img-circle" style="max-width: 120px" alt="Stella - Partner testimonial"/>
              </picture>
            </div>
            <div class="col ms-3">
              <p>
                "Croissant has been one of the best decisions we made for our business. On average, we have 15 seats open from Mon-Fri and at
                first, I thought having non-members work out of Rise would be weird or disruptive. But it's not. We've developed "regulars" that
                return and we know each other by name and face, so it's been an added benefit for our community."
              </p>
              <h4>Stella Chow | General Manager, Rise</h4>
            </div>
          </div>

          <br/>
          <br/>

          <div class="row">
            <div class="col-auto">
              <picture>
                <source srcset="/images/partners/partner-davonne.webp" type="image/webp">
                <img src="/images/partners/partner-davonne.png" class="img-responsive img-circle" style="max-width: 120px" alt="Davonne - Partner testimonial"/>
              </picture>
            </div>
            <div class="col ms-3">
              <p>
                Croissant is a great resource for the modern freelancer, remote worker, or small business owner looking to diversify their
                workspace environment. It's essential to find a workspace that lends itself to continuous inspiration and professional growth,
                and we're grateful to Croissant for connecting us with entrepreneurs and creatives that now call The Yard home!
              </p>
              <h4>DaVonne Bacchus | Head of Membership Sales, The Yard</h4>
            </div>
          </div>

          <br/>
          <br/>

          <div class="row">
            <div class="col-auto">
              <picture>
                <source srcset="/images/partners/partner-dan.webp" type="image/webp">
                <img src="/images/partners/partner-dan.png" class="img-responsive img-circle" style="max-width: 120px" alt="Dan - Partner testimonial"/>
              </picture>
            </div>
            <div class="col ms-3">
              <p>
                "We love Croissant at The Commons! Croissant provides us with a reliable and growing revenue stream and their members are an
                integral part of our community. The Croissant team is easy to work with and the app and dashboard work well – it’s a great way
                for us to fill seats and broaden our exposure to new coworkers."
              </p>
              <h4>Dan Friedland | Founder, The Commons</h4>
            </div>
          </div>

          <br/>
          <br/>

        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>

  <div class="section-form">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">

          <div class="form-panel h-100">
            <div class="row h-100">
              <div class="col-12 col-xl-7 h-100">
                <div class="form-fields-panel">

                  <h3>Connect with our partnerships team</h3>
                  <p>We're always looking to work with the best spaces around the world.</p>

                  <form (ngSubmit)="submit()" ngNativeValidate>

                    <div class="input-group">
                      <div class="form-floating">
                        <input id="name" type="text" name="name" [(ngModel)]="name" class="form-control" placeholder="Name" required>
                        <label for="name">Your name</label>
                      </div>
                    </div>

                    <br/>

                    <div class="input-group">
                      <div class="form-floating">
                        <input id="email" type="email" name="email" [(ngModel)]="email" class="form-control" placeholder="Email" required>
                        <label for="email">Email</label>
                      </div>
                    </div>

                    <br/>

                    <div class="input-group">
                      <div class="form-floating">
                        <input id="phone" type="text" name="phone" [(ngModel)]="phone" class="form-control" placeholder="Phone number" required>
                        <label for="phone">Phone number</label>
                      </div>
                    </div>

                    <br/>

                    <div class="input-group">
                      <div class="form-floating">
                        <input id="placeName" type="text" name="placeName" [(ngModel)]="placeName" class="form-control" placeholder="Space name" required>
                        <label for="placeName">Space name</label>
                      </div>
                    </div>

                    <br/>

                    <div class="input-group">
                      <div class="form-floating">
                        <input id="placeLocation" type="text" name="placeLocation" [(ngModel)]="placeLocation" class="form-control" placeholder="Location" required>
                        <label for="placeLocation">Address of your space</label>
                      </div>
                    </div>

                    <br/>

                    <button type="submit" class="btn btn-login btn-lg btn-block" style="font-size: 18px; min-height: 40px;" [disabled]="submitted">Contact Us</button>
                  </form>
                </div>
              </div>

              <div class="col-12 col-xl-5 h-100 hide-sm hide-md hide-lg">
                <div class="form-background h-100">
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

</div>
